import { graphql } from "react-relay";
import { FeedSchedulerInput } from "./FeedSchedulerInput";

export const query = graphql`
  query FeedSchedulerInputRendererQuery(
    $queryInput: String!
    $orgRelayId: ID!
    $excludeCalendars: [String]
    $emails: [String!]!
    $externalGroupRefetch: Boolean!
    $teamId: String!
    $teamAttendeesRefetch: Boolean!
  ) {
    viewer: viewer {
      ...FeedSchedulerInput_viewer
        @arguments(
          queryInput: $queryInput
          orgRelayId: $orgRelayId
          excludeCalendars: $excludeCalendars
          externalGroupRefetch: $externalGroupRefetch
        )
    }
    org: node(id: $orgRelayId) {
      ... on Org {
        ...FeedSchedulerInput_org
          @arguments(
            emails: $emails
            externalGroupRefetch: $externalGroupRefetch
            teamId: $teamId
            teamAttendeesRefetch: $teamAttendeesRefetch
          )
      }
    }
  }
`;
